<template>
  <div class="box-wrapper">
    <div class="box-content">
      <div class="mt-4 mb-4 text-center">
        <p>
          {{ error }}
        </p>
        <router-link class="btn btn-primary" :to="{ name: 'Login' }">{{
          $t("BACK")
        }}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    props: ["error"],
    data() {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>
<style></style>
